import React from 'react';
import classNames from 'classnames';

import { getPluralPhrase } from '../../utils';

interface Props {
  progress: number;
  fileName?: string;
  estTime?: number;
  isThin?: boolean;
  isBoxed?: boolean;
}

const ProgressBar: React.FC<Props> = (props) => {
  const { progress, fileName, estTime, isThin, isBoxed } = props;

  return (
    <div
      className={classNames('w-full flex flex-col gap-1', {
        'p-4 rounded-md border border-grey-200 border-solid': isBoxed,
      })}
    >
      {fileName && (
        <div className="mr-auto text-lg font-medium">{fileName}</div>
      )}

      <div
        className={classNames(
          'bg-gray-200 rounded-full overflow-hidden',
          isThin ? 'h-8' : 'h-16',
        )}
      >
        <div
          className={classNames(
            'flex p-2 items-center justify-center rounded-l-full bg-blue-green leading-none font-bold text-white transition-all',
            isThin ? 'h-8' : 'h-16 text-xl sm:text-2xl',
          )}
          style={{ width: `${progress}%` }}
        >
          {progress > (isThin ? 4 : 10) && `${progress}%`}
        </div>
      </div>

      {estTime !== undefined && (
        <div className="ml-auto text-sm opacity-50">
          Estimated time: {getPluralPhrase(estTime, 'minute')}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
